









































































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import { fetchSolicitudBaja } from './fetchSolicitudBaja';
import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Console } from 'console';
import CrearSolicitud from './Crear/CrearSolicitud.vue';
import EditarSolicitud from './Editar/EditarSolicitud.vue';
import Formulario from './Formulario.vue';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';

@Component({
  components: {
    MantenedorGrid,
    DatePicker,
    Confirmation,
    FormFieldsContainer,
    CrearSolicitud,
    EditarSolicitud,
    Formulario,
  },
})
export default class SolicitudBajaCliente extends ComponenteBase {
  dialogConfirmacionClose: boolean = false;
  filtro: string = '';
  ordesList: any[] = [];
  showModal: boolean = false;
  showImportar: boolean = false;
  showReporteGeneradoImportar: boolean = false;

  funcionalidad: Funcionalidades = Funcionalidades.SolicitudBajaCliente;

  async generarReporte(data: any) {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitudBaja(
      {
        user_id: JSON.parse(window.localStorage.user).id,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        excel: data,
        solicitud: this.editedItem,
      },
      'conecta_solicitud_baja_cliente/importar_excel'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al importar excel', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async archivoImportado(data: any) {
    await this.generarReporte(data);
    this.showImportar = false;
  }

  formFields: FormFieldDefMap = {
    estado: {
      label: 'Estado',
      value: '',
      id: '',
    },
    cliente: {
      label: 'Cliente',
      value: '',
      id: '',
    },
    motivo: {
      label: 'Motivo Tipo',
      value: '',
      id: '',
    },
    dateStart: {
      label: 'Fecha Creación Desde',
      value: moment()
        .subtract(1, 'month')
        .startOf('day'),
      id: '',
    },
    dateEnd: {
      label: 'Fecha Creación Hasta',
      value: moment().endOf('day'),
      id: '',
    },
  };

  clearFilters() {
    // this.formFields.dateStart.value = moment()
    //   .subtract(1, 'months')
    //   .startOf('day');
    // this.formFields.dateEnd.value = moment().endOf('day');
    this.clearDateFilters();
    this.formFields.estado.value = '';
    this.formFields.motivo.value = '';
    this.formFields.cliente.value = '';
  }
  clearDateFilters() {
    this.formFields.dateStart.value = moment()
      .subtract(1, 'months')
      .startOf('day');
    this.formFields.dateEnd.value = moment().endOf('day');
  }
  texto_reporte: string = '';
  showReporteGenerado: boolean = false;
  exportar() {
    this.showReporteGenerado = true;
  }

  closeReporte() {
    this.showReporteGenerado = false;
    this.showReporteGeneradoImportar = false;
  }

  async exportarExcel() {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitudBaja(
      {
        user_id: JSON.parse(window.localStorage.user).id,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        fechaInicio: moment(this.formFields.dateStart.value.toString())
          .startOf('day')
          .format('YYYY-MM-DD HH:mm'),
        fechafin: moment(this.formFields.dateEnd.value.toString())
          .endOf('day')
          .format('YYYY-MM-DD HH:mm'),
        estado: this.formFields.estado.value
          ? this.formFields.estado.value
          : '',
        motivo: this.formFields.motivo.value
          ? this.formFields.motivo.value
          : '',
        cliente: this.formFields.cliente.value
          ? this.formFields.cliente.value
          : '',
      },
      'conecta_solicitud_baja_cliente/exportar_excel'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al exportar excel', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getSolicitudes() {
    this.loadingService.showLoading();
    let self = this;
    return fetchSolicitudBaja(
      {
        fechaInicio: moment(this.formFields.dateStart.value.toString())
          .startOf('day')
          .format('YYYY-MM-DD HH:mm'),
        fechafin: moment(this.formFields.dateEnd.value.toString())
          .endOf('day')
          .format('YYYY-MM-DD HH:mm'),
        estado: this.formFields.estado.value
          ? this.formFields.estado.value
          : '',
        motivo: this.formFields.motivo.value
          ? this.formFields.motivo.value
          : '',
        cliente: this.formFields.cliente.value
          ? this.formFields.cliente.value
          : '',
      },
      'conecta_solicitud_baja_cliente/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las solicitudes', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  estados: any = ['Ejecutado', 'Solicitado', 'Anulado'];
  motivos: any = [];
  clientes: any = [];
  async getFilter() {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitudBaja(
      { '': '' },
      'conecta_solicitud_baja_cliente/get_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.motivos = data.data.MOTIVOS;
          this.clientes = data.data.CLIENTES;
          this.loadingService.hideLoading();
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ocurrió un error al cargar la información de los filtros',
          {
            timeout: 3000,
          }
        );
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async filtrar() {
    if (this.formFields.dateStart.value > this.formFields.dateEnd.value) {
      this.$snotify.error(
        'La fecha de inicio no puede ser superior a la fecha fin',
        {
          timeout: 3000,
        }
      );
      return;
    }
    this.ordesList = await this.getSolicitudes();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getSolicitudes();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };
  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };
  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };
  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };
  accionImportar: PermisoAccion = {
    accionCodigo: 108,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionCrear,
    this.accionEditar,
    this.accionExportar,
    this.accionImportar,
  ];

  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;
  loadingService = new LoadingService();
  handleErrors: HandleErrors = new HandleErrors();
  AccionesPerfilesAsociados: number = 0;

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  showModalNew: boolean = false;
  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;

  dateFormatter(params: any) {
    return params && params.movifecha_recibe != ''
      ? moment(params.value).format('YYYY-MM-DD HH:mm:ss')
      : '';
  }

  dateFormatterTramo(params: any) {
    return params && params.movifecha_recibe != ''
      ? moment(params.value).format('YYYY-MM')
      : '';
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Número',
        field: 'bajaclinumero',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 130,
        width: 130,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Creación',
        field: 'bajaclifecha_alta',
        resizable: true,
        sortable: true,
        width: 220,
        minWidth: 220,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      {
        headerName: 'Usuario',
        field: 'full_name',
        sortable: true,
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        filter: false,
      },
      {
        headerName: 'Motivo Tipo',
        field: 'motiname',
        width: 300,
        minWidth: 300,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Observación',
        field: 'bajacliobs',
        width: 250,
        minWidth: 250,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Tramo',
        field: 'bajaclitramo',
        width: 250,
        minWidth: 250,
        lockPinned: true,
        sortable: true,
        resizable: true,
        valueFormatter: this.dateFormatterTramo,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Cantidad Clientes',
        field: 'bajaclicant',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Cantidad Equipos',
        field: 'bajaclicant_equipos',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Fecha Ejecuta',
        field: 'bajaclifecha_ejecuta',
        resizable: true,
        sortable: true,
        width: 225,
        minWidth: 225,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      makeAccionesColumnDef(this.funcionalidad),
    ];

    this.gridOptions = {
      pagination: true,
      domLayout: 'autoHeight',
      paginationPageSize: 50,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      rowSelection: 'multiple',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('YYYY-MM-DD');
  }

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.SolicitudBajaCliente) {
        if (data.action === Accion.Editar) {
          this.editedItem = null;
          // Editar - Ver Detalle
          this.modalEsEdicion = data.action == Accion.Editar;

          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.showModalEdit = true;
            this.editedItem = data.cellRendererParams.data.bajaclinumero;
          }
        } else if (data.action === Accion.accionImportar) {
          this.editedItem = null;
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            const estado = data.cellRendererParams.data.estado.toUpperCase();
            // console.log(estado);
            if (estado === 'EJECUTADO' || estado === 'ANULADO') {
              this.$snotify.error(
                'No es posible importar con el estado de la solicitud en ' +
                  estado,
                {
                  timeout: 3000,
                }
              );
              return false;
            } else {
              this.showImportar = true;
              this.editedItem = data.cellRendererParams.data.bajaclinumero;
            }
          }
        }
      }
    });
  }

  mounted() {
    this.initialize();
    this.getFilter();
  }

  moduloModalCallback(val: boolean) {
    this.showModal = val;
    this.showModalNew = val;
    this.modalEsEdicion = val;
    this.showImportar = val;
    this.showModalEdit = val;
    this.filtrar();
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
  }
  validaFecha() {
    const dateStart = this.formFields.dateStart.value;
    const dateEnd = this.formFields.dateEnd.value;
    // console.log("dateStart " + dateStart, "dateEnd " + dateEnd);
    if (dateStart > dateEnd) {
      this.$snotify.error(
        'La fecha de creación desde no puede ser superior a la fecha de creación hasta',
        {
          timeout: 3000,
        }
      );
      this.clearDateFilters();
    }
  }
}
